import { render, staticRenderFns } from "./ContactBankdraftsComponent.vue?vue&type=template&id=2400150c"
import script from "./ContactBankdraftsComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactBankdraftsComponent.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2400150c')) {
      api.createRecord('2400150c', component.options)
    } else {
      api.reload('2400150c', component.options)
    }
    module.hot.accept("./ContactBankdraftsComponent.vue?vue&type=template&id=2400150c", function () {
      api.rerender('2400150c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactBankdrafts/ContactBankdraftsComponent.vue"
export default component.exports